import { ContentLibraryContentDto } from '@asset-metrix/portal-gateway-client-js';

export function contentTitle(
  item: ContentLibraryContentDto,
  untitledLabel: string
): string {
  const title = item.content.title?.trim() || untitledLabel;
  const groupLabel = item.groupLabel?.trim();
  if (!groupLabel) {
    return title;
  }
  return `${groupLabel} - ${title}`;
}

function contentEntityType(item: ContentLibraryContentDto): string | undefined {
  return item.content.entity?.type;
}

function sortByTitle(
  contents: ContentLibraryContentDto[],
  untitledLabel: string
): ContentLibraryContentDto[] {
  return [...contents].sort((left, right) =>
    contentTitle(left, untitledLabel).localeCompare(
      contentTitle(right, untitledLabel),
      undefined,
      { sensitivity: 'base' }
    )
  );
}

export function groupContentsForDisplay(
  contents: ContentLibraryContentDto[],
  untitledLabel: string
): ContentLibraryContentDto[] {
  const tables = sortByTitle(
    contents.filter((item) => contentEntityType(item) === 'table'),
    untitledLabel
  );
  const charts = sortByTitle(
    contents.filter((item) => contentEntityType(item) === 'vegaChart'),
    untitledLabel
  );
  return [...tables, ...charts];
}
